import { injectable } from 'inversify';
import { store } from '../../store';
import { usePlayerTemplateUrlSelector } from './downloadPlayerTemplate.slice';
import {
  downloadPlayerTemplateThunk,
  templateTypePlayer,
} from './downloadPlayerTemplate.thunk';

@injectable()
export class DownloadPlayerTemplateService {
  usePlayerTemplateUrlSelector = usePlayerTemplateUrlSelector;
  dispatchDownloadPlayerTemplate() {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    store
      .dispatch(downloadPlayerTemplateThunk(templateTypePlayer))
      .unwrap()
      .then(() => {});
  }
}
